/**
 * created by mleitzell on 12/20/17.
 */
import DataSource from "common/framework/DataSource";

export default DataSource.extend({

    init: function() {
        var config = {
            transport: {
                parameterMap: "default",
                read: {
                    url: context.path + "/webservices/rest/license/concurrent",
                    type: "GET",
                    contentType: "application/json"
                }
            }
        };

        DataSource.fn.init.call(this, config);
    }
});
